import { queryOptions, useQuery } from '@tanstack/react-query'

import { ApiGateway } from '@/modules/api/api.gateway'
import { RefusalReasonRepository } from '@/modules/refusal-reason/core/refusal-reason.repository'
import { RefusalReasonService } from '@/modules/refusal-reason/core/refusal-reason.service'

const apiGateway = new ApiGateway()
const refusalReasonRepository = new RefusalReasonRepository(apiGateway)
const refusalReasonService = new RefusalReasonService(refusalReasonRepository)

const refusalReasonsQueryOptions = queryOptions({
  queryFn: () => refusalReasonService.getAll(),
  queryKey: ['refusalReasons'],
  staleTime: Infinity,
})

export const useRefusalReasons = () => {
  return useQuery(refusalReasonsQueryOptions)
}
